// The type filter of the site search, as it appears in the URL
// (`/suche?search=…&typ=…`). Order = order in the dropdown.
export const SearchType = {
  All: 'alle',
  Products: 'produkte',
  Services: 'dienstleistungen',
  Posts: 'beitraege',
  Specials: 'aktionen',
  Dates: 'termine',
  Jobs: 'jobs',
  Events: 'veranstaltungen',
  Vendors: 'unternehmer'
} as const;

export type SearchTypeValue = (typeof SearchType)[keyof typeof SearchType];

export const SEARCH_TYPES: SearchTypeValue[] = Object.values(SearchType);

/** A `typ` from the URL; anything unknown or missing searches everything. */
export const parseSearchType = (value: unknown): SearchTypeValue =>
  SEARCH_TYPES.find((type) => type === value) ?? SearchType.All;

/** The search page URL. "Alle" is the default, so it stays out of the URL. */
export const getSearchPath = (term: string, type: SearchTypeValue): string =>
  `/suche?search=${encodeURIComponent(term)}${type === SearchType.All ? '' : `&typ=${type}`}`;
